import React, { Component } from "react"
import FooterComponent from "./../../Generic/Footer/FooterComponent"
import HeaderComponent from "./../../Generic/Header/HeaderComponent"
import ImageCrousel from "./ProductInfo/ImageCrousel"
import ProductInfoComponent from "./ProductInfo/ProductInfoComponent"
import * as endpoint from "./../../../Service/endpoints"
import * as service from "./../../../Service/service"
import H2Title from "./../../Generic/Element/Heading"
import SingleProduct from "./../../Generic/Element/SingleProduct"
import BreadCrumbs from "./../../Generic/BreadCrumbs/BreadCrumbs"
import { connect } from "react-redux"
import ProductSepcifications from "././ProductInfo/ProductSepcifications"
import ProductFAQComponent from "././ProductInfo/ProductFAQComponent"
import ResponseForm from "../Homepage/GoogleForm/ResponseForm"
import ServiceAreaSelect from "../Homepage/ServiceArea/ServiceAreaSelect"
import SeoMeta from "./../../Generic/SEO/SeoMeta"

class ProductComponent extends Component {
  state = {
    product: {
      featureList: [],
      gallery: {
        images: [],
      },
    },
    productSlug: "",
    inventory: {
      rentOption: [],
    },
    durationSelected: 12,
    quantity: 1,
    showSpinner: false,
    showOptions: false,
    searched: "",
    recommendItem: [],
    isLoaded: false,
    openResponseForm: false,
    slugs: [],
  }

  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      productSlug: props.match.params.productSlug,
    }
  }

  componentDidMount() {
    this.getProductData()
    this.props.updateBreadcumbs({
      navigation: [
        { name: "Home", link: endpoint.getRoute("") },
        { name: "Product", link: "#" },
      ],
      showSidebar: false,
      sidebar: [],
    })
  }

  manageQuantity = (op) => {
    if (op == "+") {
      if (this.state.quantity < this.state.product.inventory) {
        this.setState({
          ...this.state,
          quantity: Number.parseInt(this.state.quantity) + 1,
        })
      } else {
        alert(`You can only add up to ${this.state.product.inventory} items.`)
      }
    } else if (op == "-") {
      if (this.state.quantity != 1) {
        this.setState({
          ...this.state,
          quantity: Number.parseInt(this.state.quantity) - 1,
        })
      }
    }
  }

  getProductData = () => {
    service.getSingleProduct(this.state.productSlug).then(
      (response) => {
        this.setState({
          ...this.state,
          product: response.data,
          isLoaded: true,
        })
        if (this.state.product.isMedical) {
          this.setState({ durationSelected: 1 })
        }
        this.checkProductInventory(response.data.id)
        this.getRecommendedItem(response.data.id)
      },
      (error) => {
        console.log(error)
      },
    )
  }

  checkProductInventory = (productId) => {
    service.checkInventory(productId).then(
      (response) => {
        this.setState({
          ...this.state,
          inventory: response.data,
        })
      },
      (error) => {
        console.log(error)
      },
    )
  }

  selectDuration = (e) => {
    this.setState({
      ...this.state,
      durationSelected: Number.parseInt(e.target.value),
    })
  }

  showPrice = (type) => {
    if (type == "single") {
      let price = "0"
      this.state.inventory.rentOption.map((rent) => {
        if (rent.period == this.state.durationSelected) {
          price = rent.price
        }
      })
      return price
    } else if (type == "final") {
      let price = "0"
      this.state.inventory.rentOption.map((rent) => {
        if (rent.period == this.state.durationSelected) {
          price = rent.price
        }
      })
      return price * this.state.quantity
    }
  }

  addItemToCart = () => {
    if (this.state.product.instantDelivery && this.state.quantity > this.state.product.inventory) {
      alert(`You can only add up to ${this.state.product.inventory} items.`)
      return
    }

    if (this.props.userState.loggedIn) {
      this.setState({
        ...this.state,
        showSpinner: true,
      })

      service
        .checkCart()
        .then((response) => {
          const cartItems = response.data.cartProductList || []

          if (cartItems.length > 0) {
            if (cartItems[0].isPremium && this.state.product.category.slug !== "premium") {
              alert("Please add only premium products or remove premium products from the cart to continue.")
              this.setState({ ...this.state, showSpinner: false })
              return
            } else if (!cartItems[0].isPremium && this.state.product.category.slug === "premium") {
              alert("Please add only non-premium products or remove non-premium products from the cart to continue.")
              this.setState({ ...this.state, showSpinner: false })
              return
            } else {
              this.updateCart()
            }
          } else {
            this.updateCart()
          }
        })
        .catch((error) => {
          console.error("Error checking cart:", error)
          this.setState({ ...this.state, showSpinner: false })
        })
    } else {
      this.props.showLoginWindow()
    }
  }

  updateCart = () => {
    const cart = {
      productId: this.state.product.id,
      productSlug: this.state.product.slug,
      tenure: this.state.product.isMedical == true ? 1 : this.state.durationSelected,
      quantity: this.state.quantity,
      monthlyRent: this.showPrice("final"),
      securityDeposit:
        this.state.product.category.slug === "seasonal" ? 0 : Number.parseFloat(this.showPrice("final")) * 1,
      isMedical: this.state.product.isMedical == true ? true : false,
      isPremium: this.state.product.category.slug === "premium" ? true : false,
      isSeasonal: this.state.product.category.slug === "seasonal" ? true : false,
      isExpress: this.state.product.instantDelivery,
    }

    service.addToCart(cart).then(
      (response) => {
        this.setState({
          ...this.state,
          showSpinner: false,
          showOptions: true,
        })
      },
      (error) => {
        console.log(error)
      },
    )
  }

  getRecommendedItem = (pid) => {
    service.recommendedItems(pid).then(
      (response) => {
        this.setState({
          ...this.state,
          recommendItem: response.data,
        })
      },
      (error) => {
        console.log(error)
      },
    )
  }
  getExpressDeliverySlotAndCountdown = () => {
  const now = new Date();
  const deliveryDate = new Date(now);
  let label = "";
  let cutoff = new Date();

  if (now.getHours() >= 12) {
    // After 1PM => Next day delivery
    deliveryDate.setDate(now.getDate() + 1);
    label = "Next Day Delivery";

    // Time left for placing order: till 11:00 PM today
    cutoff.setHours(23, 59, 59, 999);
  } else {
    // Before 12PM => Same day delivery
    label = "Same Day Delivery";

    // Time left for same-day: till 1:00 PM today
    cutoff.setHours(12, 0, 0, 0);
  }

  // Calculate countdown
  const diffMs = cutoff - now;
  let countdown = "0Hr 0m";

  if (diffMs > 0) {
    const totalSeconds = Math.floor(diffMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    countdown = `${hours}Hr ${minutes}m ${seconds}s`;
  }

  const options = { day: 'numeric', month: 'long' };
  const formattedDate = deliveryDate.toLocaleDateString('en-IN', options);

  return {
    label,                        // "Same Day Delivery" or "Next Day Delivery"
    deliverySlot: `${formattedDate} `, // e.g., "10 July "
    countdown,
    deliveryDate                    // e.g., "2Hr 23m 12s"
  };
};

getExpressDeliveryDate = () => {
  const now = new Date();
  const cutoffHour = 13; // 1:00 PM

  const deliveryDate = new Date(now);

  // If current time is after or at 1:00 PM, set delivery to tomorrow
  if (now.getHours() >= cutoffHour) {
    deliveryDate.setDate(now.getDate() + 1);
  }

  const options = { day: 'numeric', month: 'long' };
  return deliveryDate.toLocaleDateString('en-IN', options);
};

getExpressDeliveryTime = () => {
  const now = new Date();
  const target = new Date();

  target.setHours(23, 0, 0, 0); // Countdown till 11 PM

  if (now >= target) return "0Hr 0m";

  const diffMs = target - now;
  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours}Hr ${minutes}m ${seconds}s`;
};

    
    // componentDidMount() {

    //     this.intervalId = setInterval(() => {
    //         this.setState({ timeLeft: this.getExpressDeliveryTime() });
    //     }, 1000);
    // }
  responseForm() {
    this.setState({ ...this.state, openResponseForm: true })
  }

  render() {
    const citySlug = this.props.match?.params?.city || "delhi"
    const currentCity = endpoint.getCurrentCity()
    const categorySlug = this.props.match?.params?.category || this.state.product.category?.slug || ""
    const subCategorySlug =
      this.props.match?.params?.subCategory || this.state.product.subCategory?.slug || ""
    const productName = this.state.product.name || "Product"
    const productDescription =
      this.state.product.description ||
      `Rent ${productName} online with flexible plans from Voorent.`
    const canonical = `https://voorent.com/${citySlug}/${categorySlug}/${subCategorySlug}/${this.state.productSlug}`
    const structuredData = this.state.product.id
      ? {
          "@context": "https://schema.org",
          "@type": "Product",
          name: productName,
          description: productDescription,
          image: this.state.product.featuredImage,
          brand: {
            "@type": "Brand",
            name: "Voorent",
          },
          offers: {
            "@type": "Offer",
            priceCurrency: "INR",
            price: this.state.product.startingFrom,
            availability: "https://schema.org/InStock",
            url: canonical,
          },
        }
      : null

    setTimeout(() => this.responseForm(), 5000)
    return (
      <React.Fragment>
        {this.state.product.id ? (
          <SeoMeta
            title={`${productName} on Rent | Voorent`}
            description={productDescription}
            canonical={canonical}
            image={this.state.product.featuredImage}
            structuredData={structuredData}
          />
        ) : null}

        {window.location.href.indexOf("medium") > -1 && (
          <div>
            {this.state.openResponseForm && <ResponseForm />}
            {!this.props.surveyModal.show && <ServiceAreaSelect />}
          </div>
        )}
        <HeaderComponent />

        <BreadCrumbs
          navigation={[
            { name: "Home", link: endpoint.getRoute("") },
            { name: "Products", link: "#" },
          ]}
          showSidebar={false}
        />
        <div>
          {!this.state.isLoaded && (
            <div className="col-12 m-auto">
              <div className="row">
                <div className="col-12 text-center mt-5">
                  <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <span className="pl-3 text-black-50 d-block">Checking Inventory ..</span>
                </div>
              </div>
            </div>
          )}

          {this.state.isLoaded && this.state.product.length === 0 && (
            <div className="col-12">
              <div className="row">
                <div className="col-12 text-center mt-5">
                  <img height="80px" src="./../svg/noresult.svg" />
                  <h5 className="mt-3 mb-5 text-black-50">Sorry ! No Items available with following search option.</h5>
                </div>
              </div>
            </div>
          )}

          {this.state.isLoaded && (
            <main role="main" className="container mt-5">
              {this.state.product.instantDelivery && currentCity === "gurgaon" && (
                <div className="alert alert mb-4" role="alert" style={{backgroundColor:'#004a80', color:'#ffffff'}}>
                  <strong>Express Delivery Available!</strong>
                  {" "} <img src="/svg/ExpressDelivery.svg" alt="Express Delivery" style={{ width: 18, height: 18, marginRight: 8 }} />
                  {new Date().getHours() < 13
                    ? "If ordered before 12 PM, your product will be delivered today "
                    : "If ordered now, your product will be delivered by tomorrow."}
                </div>
              )}
              <div className="row">
                <div className="col-12 col-md-6">
                  <ImageCrousel
                    featuredImage={this.state.product.featuredImage}
                    images={this.state.product.gallery.images}
                    status={this.state.product.status}
                    isPremium={this.state.product.category.slug === "premium"}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <ProductInfoComponent
                    showSpinner={this.state.showSpinner}
                    showOptions={this.state.showOptions}
                    addItemToCart={this.addItemToCart}
                    quantity={this.state.quantity}
                    manageQuantity={this.manageQuantity}
                    durationSelected={this.state.durationSelected}
                    showPrice={this.showPrice}
                    selectDuration={this.selectDuration}
                    inventory={this.state.inventory}
                    product={this.state.product}
                    getExpressDeliveryDate={this.getExpressDeliveryDate}
                    getExpressDeliveryTime ={this.getExpressDeliveryTime}
                    getExpressDeliverySlotAndCountdown = {this.getExpressDeliverySlotAndCountdown}
                    

                    
                  />
                </div>
              </div>
              <br />

              <div>
                <ul className="nav nav-pills  " role="tablist">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      id="product-detail-link"
                      data-toggle="tab"
                      href="#product-detail-tab"
                      role="tab"
                      aria-controls="product-detail-tab"
                      aria-selected="true"
                    >
                      Product Details
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      id="product-faq-link"
                      data-toggle="tab"
                      href="#product-faq-tab"
                      role="tab"
                      aria-controls="product-faq-tab"
                      aria-selected="false"
                    >
                      FAQ
                    </a>
                  </li>
                </ul>

                <div className="tab-content">
                  <div
                    className="tab-pane fade active show"
                    id="product-detail-tab"
                    role="tabpanel"
                    aria-labelledby="product-detail-link"
                  >
                    <div className="product-detail-content">
                      <div className="col-12 mt-3 pl-0" style={{ border: "1px solid #DDD" }}>
                        <div className="row p-3">
                          {this.state.product.featureList.length != 0 &&
                            this.state.product.featureList.map((spec, sIndex) => (
                              <ProductSepcifications key={sIndex} specs={spec} />
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="product-faq-tab"
                    role="tabpanel"
                    aria-labelledby="product-faq-link"
                  >
                    <div className="product-faq-content">
                      <ProductFAQComponent />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12">
                  <H2Title value={"You may also like this"} />
                  <div className="text-secondary ml-2 mb-3">Products recommendation based on your search activity.</div>

                  <div className="row">
                    {this.state.recommendItem.length != 0 &&
                      this.state.recommendItem.map(
                        (prod, index) =>
                          index < 4 && (
                            <SingleProduct
                              length={this.state.recommendItem.length}
                              minTenure={prod.isMedical ? "1 Month" : "6 Months"}
                              key={index}
                              product={prod}
                              styleValue={{ padding: "" }}
                            />
                          ),
                      )}
                  </div>
                </div>
              </div>
            </main>
          )}
        </div>
        <FooterComponent />
      </React.Fragment>
    )
  }
}

const mapStateToProps = (currentState) => {
  return {
    userState: currentState.userState,
    surveyModal: currentState.surveyModal,
  }
}

const mapActionsToProps = (dispatch) => {
  return {
    updateBreadcumbs: (data) => {
      dispatch({ type: "breadcrumbs.update", data: data })
    },
    showLoginWindow: () => {
      dispatch({ type: "login.window.show" })
    },
  }
}

export default connect(mapStateToProps, mapActionsToProps)(ProductComponent)
